import { RefObject, useLayoutEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface UseSmartBannerHook {
  appName: string;
  appDescription: string;
  buttonText: string;
  show: boolean;
  offsetHeight: number;
}

export const useSmartBanner = ({
  landingPages = [],
  ref,
}: {
  landingPages?: Array<string>;
  ref: RefObject<HTMLDivElement>;
}): UseSmartBannerHook => {
  const { t } = useTranslation('shared');
  const router = useRouter();
  const [offsetHeight, setOffsetHeight] = useState(0);

  useLayoutEffect(() => {
    if (ref.current?.offsetHeight) {
      setOffsetHeight(ref.current.offsetHeight);
    }
  }, [ref.current?.offsetHeight]);

  return {
    appName: t('shared_webToAppBanner_appTitle_stihlApp'),
    appDescription: t('shared_webToAppBanner_description_stihlApp'),
    buttonText: t('shared_webToAppBanner_buttonView_stihlApp'),
    show: useFlags()?.['smart-app-banner'] && landingPages.includes(router.pathname),
    offsetHeight,
  };
};
